<div class="col-12 mt-4 ml-0 pl-0 mb-3">
  <a class="cursor-pointer color-negro btn-volver" (click)="validarVolver();" data-toggle="tooltip" data-placement="top" title="VOLVER" alt="VOLVER">
    <i class="bi bi-chevron-left mr-2"></i>
    Volver
  </a>
</div>
<h1 class="d-xl-none">Registro de calificaciones</h1>

<!-- DATOS SECCIÓN -->
<div class="py-2 my-5 borde_inferior_datos_secciones borde_superior_datos_secciones d-xl-none">
  <p class="mb-1 mt-3 text-uppercase">{{asignatura?.asignatura}}</p>
  <p class="mb-1 text-uppercase">{{asignatura?.periodo}}</p>
  <p class="mb-1 text-uppercase" *ngFor="let docente of docentes">{{docente.docente}}</p>
  <p class="mb-3 text-uppercase">{{asignatura?.sede}}</p>
</div>
<!-- FIN SECCIÓN -->


<div class="titulo-configuracion-ponderacion text-center d-xl-none">
  CONFIGURACIÓN DE PONDERACIONES
</div>
<!-- CALIFICACIONES PARCIALES -->

<div class="mt-3 fondo_gris d-xl-none">
  <div class="row">
    <div class="col-9 col-sm-10 col-md-10 col-lg-11">
      <p class="mb-0 mx-5 pt-3 tamanio-texto-calificaciones_responsive">
        <strong>CALIFICACIONES PARCIALES</strong>
      </p>
    </div>
    <div class="col">
      <button class="btn" (click)="showCp = !showCp"><i [ngClass]="!showCp ? 'bi-plus-circle' : 'bi-dash-circle'" class="bi tamanio_iconos-boton ml-3"></i></button>
    </div>
  </div>
</div>

<div class="d-xl-none" *ngIf="showCp">
  <ng-container *ngFor="let header of tablaCalificaciones?.headers; let indexHeader = index">
    <ng-container *ngIf="header.tipoNota === 'CP'">
      <div class="row justify-content-center mt-5">
        <button class="boton-secundario" style="width: 80%;" (click)="calificarAlumnos(header, indexHeader)">{{ header.valor }}</button>
      </div>
      <p class="text-center mt-3 mb-0"><strong>{{ alumnosSinCalifaciones(indexHeader) }}</strong></p>
      <p class="text-center datos_alumnos-RUT">ALUMNOS SIN INGRESO DE CALIFICACIONES</p>
    </ng-container>
  </ng-container>
</div>


<!-- FIN CALIFICACIONES PARCIALES -->

<!-- CALIFICACIÓN EXAMENES -->

<div class="mt-5 fondo_gris d-xl-none">
  <div class="row">
    <div class="col-9 col-sm-10 col-md-10 col-lg-11">
      <p class="mb-0 mx-5 pt-3 tamanio-texto-calificaciones_responsive"><strong>CALIFICACIÓN EXAMEN</strong></p>
    </div>
    <div class="col">
      <button class="btn" (click)="showCe = !showCe"><i [ngClass]="!showCe ? 'bi-plus-circle' : 'bi-dash-circle'" class="bi tamanio_iconos-boton ml-3"></i></button>
    </div>
  </div>
</div>

<div class="d-xl-none" *ngIf="showCe">
  <ng-container *ngFor="let header of tablaCalificaciones?.headers; let indexHeader = index">
    <ng-container *ngIf="header.tipoNota === 'CE' || header.tipoNota === 'EX'">
      <div class="row justify-content-center mt-5">
        <button class="boton-secundario" style="width: 80%;" (click)="calificarAlumnos(header, indexHeader)">{{ header.valor }}</button>
      </div>
      <p class="text-center mt-3 mb-0"><strong>{{ alumnosSinCalifaciones(indexHeader) }}</strong></p>
      <p class="text-center datos_alumnos-RUT">ALUMNOS SIN INGRESO DE CALIFICACIONES</p>
    </ng-container>
  </ng-container>
</div>
<!-- FIN CALIFICACIÓN EXAMENES -->

<div class="row justify-content-center mt-5 d-xl-none pb-3">
  <button class="boton_descarga_registro_calificaciones mt-4" (click)="descargarRegistroCalificaciones()">
    <i class="bi bi-filetype-xlsx tamanio_iconos-boton mr-3"></i>
      Registro de calificaciones (Excel)
  </button>

  <button *ngIf="registrosEditables" (click)="cerrarSeccion()" class="boton-secundario mt-5 btn-cerrar-curso" style="width: 80%;">
    cerrar curso
  </button>
</div>

<!-- MODAL CERRAR CURSO -->
<button id="modal-confirmar-cierre-seccion" class="btn d-none" data-toggle="modal" data-target="#confirmar">CERRAR CURSO 1</button>
<div class="modal fade" id="confirmar" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
          <div class="modal-header align-items-center">
              <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Atención</h1>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
                  <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
              </button>
          </div>
          <div class="modal-body">
              <form>
                  <div class="row align-items-center my-3 mx-4">
                      <p class="mb-0 ml-3">¿Estás seguro/a que deseas cerrar el curso?</p>
                      <span class="ml-3 mt-2">Al presionar botón ‘SI’, no podrás realizar modificaciones.</span>
                  </div>
              </form>
          </div>
          <div class="modal-footer justify-content-center">
              <div class="my-4">
                <button
                  class="boton_secundario_modal ml-3"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="NO"
                  alt="NO" data-dismiss="modal"
                  id="btn-cerrar-modal-cierre-seccion"
                >
                  NO
                </button>
                <button
                  class="boton_secundario_modal boton-primario-modificado ml-3"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="SI" alt="SI" (click)="confirmarCierreSeccion()">
                  SI
                </button>
              </div>
          </div>
      </div>
  </div>
</div>
<!-- FIN MODAL CERRAR CURSO -->


<!-- MODAL SIN INGRESO DE CALIFICACIÓN -->
<button id="modal-estudiantes-sin-calificaciones" class="btn d-none" data-toggle="modal" data-target="#confirmar2">CERRAR CURSO 2</button>
<div class="modal fade" id="confirmar2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
          <div class="modal-header align-items-center">
              <h1 class="modal-title mt-0 ml-4" id="exampleModalLabel">Atención</h1>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="CERRAR" alt="CERRAR">
                  <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
              </button>
          </div>
          <div class="modal-body">
              <form>
                  <div class="row align-items-center my-3 mx-4">
                      <p class="mb-0 ml-3">No puedes cerrar el curso, ya que aún hay estudiantes sin ingreso de calificación.</p>
                      <span class="ml-3 mt-2">Las celdas no deben contener calificación 0,0.</span>
                  </div>
              </form>
          </div>
          <div class="modal-footer justify-content-center">
              <div class="my-4">
                <button
                  class="boton_secundario_modal ml-3"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Aceptar" alt="Aceptar" data-dismiss="modal">
                  Aceptar
                </button>
              </div>
          </div>
      </div>
  </div>
</div>
<!-- FIN MODAL SIN INGRESO DE CALIFICACIÓN -->

<app-modal-info modalId="modal-info" [titulo]="infoModalTitulo" [texto]="infoModalTexto"></app-modal-info>
<button id="btn-modal-info" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-info">
	Modal info
</button>